<template>
  <div>
<!--    <div v-if="getTeams.length">-->
    <div>
      <unicon class="file-icon mt-2 ml-2" name="folder-download"></unicon>
      <SitesList v-model="campaignSite"/>
      <input
        @change="selectFiles"
        type="file"
        class="input mt-2 mr-2"
        id="file-upload" multiple/>
      <input
        type="text"
        class="discrete input mt-2 ml-2"
        placeholder="Nom de la campagne"
        v-model="campaign"/>
      <label class="ml-2 mr-2" for="robustesse-checkbox">Robustesse</label>
      <input type="radio" name="is-robustesse"
             id="robustesse-checkbox"
             class="checkbox"
             :value="'Robustesse'" v-model="isRobustesse"
             @click="confrontationReset()">
      <label class="ml-2 mr-2" for="deresma-checkbox">Deresma ind.E</label>
      <input type="radio" name="is-robustesse"
             id="deresma-checkbox"
             class="checkbox"
             :value="'Deresma ind.E'" v-model="isRobustesse"
             @click="confrontationCheck()">

      <label class="ml-2 mr-2" for="deresma-checkbox">Deresma Gaine</label>
      <input type="radio" name="is-robustesse"
             id="deresma-checkbox"
             class="checkbox"
             :value="'Deresma Gaine'" v-model="isRobustesse"
             @click="confrontationCheck()">

      <br>
      <label class="ml-2 mr-2" for="tts-checkbox">TTS</label>
      <input type="radio" name="is-tts"
             id="tts-checkbox"
             class="checkbox"
             :value="true" v-model="isTTS">
      <label class="ml-2 mr-2" for="confrontation-checkbox">Confrontation</label>
      <input type="radio" name="is-tts"
             id="confrontation-checkbox"
             class="checkbox"
             :value="false" v-model="isTTS">
      <input
        v-if="campaignCalculatedName.length > 2 && campaignSite && selectedFilesCount > 0 && isRobustesse !== null"
        type="button"
        class="mt-2 ml-2 button"
        value="Charger les fichiers"
        @click="uploadProcess" />
      <br/>
    </div>
<!--    <section class="info ml-2" v-else>-->
<!--      Avant de pouvoir créer une campagne, il faut constituer des équipes en cliquant sur le bouton en haut à droite-->
<!--    </section>-->

    <div id="ExcelTable"></div>
  </div>
</template>

<script lang="js">
import Vue from 'vue'
import XLSX from 'xlsx'
import { DeresmaForm, DeresmaGaineForm, RobustesseForm } from '@/models/SeismicForm.ts'
import SitesList from '@/components/SitesList'
import { mapGetters } from 'vuex'

export default Vue.extend({
  name: 'XLSXFileUpload',
  components: {
    SitesList
  },
  data: () => {
    return {
      campaign: '',
      isTTS: null,
      isRobustesse: null,
      selectedTeam: undefined,
      selectedFilesCount: 0,
      campaignSite: undefined
    }
  },
  computed: {
    ...mapGetters(['getTeams']),
    campaignCalculatedName () {
      return this.campaignSite ? this.campaignSite + '-' + (new Date().getMonth() + 1) + '-' + new Date().getFullYear() : ''
    }
  },
  watch: {
    // CalculatedCampaignName is useful to autogenerate a name, but since it can be
    // manually modified, the reference remains this.campaign
    campaignCalculatedName () {
      this.campaign = this.campaignCalculatedName
    }
  },
  methods: {

    selectFiles (ev) {
      this.selectedFilesCount = ev.target.files.length
    },

    uploadProcess: function () {
      const fileUpload = document.getElementById('file-upload')

      // Validate whether File is valid Excel file.
      const regex = /^([a-zA-Z0-9\s_\\.\-:])+(.xlsx)$/
      if (regex.test(fileUpload.value.toLowerCase())) {
        if (typeof (FileReader) !== 'undefined') {
          const reader = new FileReader()
          if (reader.readAsBinaryString) {
            reader.onload = () => {
              for (let i = 0; i < fileUpload.files.length; i++) {
                this.readFileAsText(fileUpload.files[i])
              }
            }
            reader.readAsBinaryString(fileUpload.files[0])
          }
        } else {
          alert('Ce navigateur semble incompatible avec l\'application')
        }
      } else {
        alert('Le fichier uploadé ne semble pas être valide.')
      }
    },

    readFileAsText: function (file) {
      const campaign = this.campaign
      // eslint-disable-next-line @typescript-eslint/no-this-alias
      const self = this
      return new Promise(function (resolve, reject) {
        const fr = new FileReader()

        fr.onload = () => {
          const workbook = XLSX.read(fr.result, { type: 'binary' })
          const Sheet = workbook.SheetNames[0]
          let matrix = XLSX.utils.sheet_to_csv((workbook.Sheets[Sheet]), { RS: "§§§§§§§§§§" })
          console.log("MATRIX INIT ", matrix)
          matrix = matrix.split('§§§§§§§§§§')

          console.log('CONTENU FICHIER', matrix.map(item => self.parseCSVRow(item)))
          let seismicForm
          if (self.isRobustesse === "Robustesse") {
            seismicForm = new RobustesseForm(campaign, self.isRobustesse, self.isTTS, matrix.map(item => self.parseCSVRow(item)), [self.campaignSite])
            // Hard-coded values to match agency prerequisites:
            seismicForm.isCat23nc = true

            self.$emit('change', seismicForm)
            self.$el.querySelector('#file-upload').value = ''
            resolve(fr.result)
          } else if (self.isRobustesse === "Deresma ind.E") {
            const fiches = self.sortMatrix(matrix.map(item => self.parseCSVRow(item)), 18)
            console.log('SORTED DATA', fiches)
            for (const ficheName in fiches) {
              seismicForm = new DeresmaForm(campaign, self.isRobustesse, self.isTTS, fiches[ficheName], [self.campaignSite])
              seismicForm.isCat23nc = true

              self.$emit('change', seismicForm)
              self.$el.querySelector('#file-upload').value = ''
              resolve(fr.result)
            }
          } else if (self.isRobustesse === "Deresma Gaine") {
            const fiches = self.sortMatrix(matrix.map(item => self.parseCSVRow(item)), 6)
            for (const ficheName in fiches) {
              seismicForm = new DeresmaGaineForm(campaign, self.isRobustesse, self.isTTS, fiches[ficheName], [self.campaignSite])
              seismicForm.isCat23nc = true

              self.$emit('change', seismicForm)
              self.$el.querySelector('#file-upload').value = ''
              resolve(fr.result)
            }
          }
        }

        fr.onerror = function () {
          reject(fr)
        }

        fr.readAsBinaryString(file)
      })
    },

    parseCSVRow (csvRow) {
      let isWithinComa = false
      let currentCellBuffer = ''
      const output = []
      for (const char of csvRow.split('')) {
        if (char === '"') {
          isWithinComa = !isWithinComa
        } else if (isWithinComa) {
          currentCellBuffer += char
        } else if (char !== ',') {
          currentCellBuffer += char
        } else if (char === ',') {
          output.push(currentCellBuffer)
          currentCellBuffer = ''
        }
      }
      output.push(currentCellBuffer)
      return output
    },

    confrontationCheck () {
      document.getElementById('confrontation-checkbox').checked = true
    },

    confrontationReset () {
      document.getElementById('confrontation-checkbox').checked = false
    },

    sortMatrix (matrix, column) {
      // TODO regarder dans la colonne AN si le nom du site correspond à la campagne créée
      const fiches = {}
      for (let i = 1; i < matrix.length; i++) {
        if (Object.keys(fiches).includes(matrix[i][column])) {
          fiches[matrix[i][column]].push(matrix[i])
        } else {
          fiches[matrix[i][column]] = [matrix[i]]
        }
      }
      if (Object.keys(fiches).includes('undefined')) {
        delete fiches.undefined
      }
      if (Object.keys(fiches).includes('')) {
        delete fiches['']
      }
      return fiches
    }

  }

})
</script>

<style lang="stylus">
  .discrete.input {
    border: 0
    color: #555
  }

</style>
